import gql from 'graphql-tag';

export const ClearRestrictionsForFreeMutation = gql`
	mutation ClearRestrictionsForFreeMutation($contentId: ID!) {
		clearRestrictionsForFree(contentId: $contentId) {
			restrictionsHash
		}
	}
`;
